module.exports = __webpack_public_path__ + "static/media/CTLA_6-383w.b46b705c.webp";